module.exports = __webpack_public_path__ + "img/aierlogo3.74680d88.png";